var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"column":""}},[_c('CoreHeader',{attrs:{"large":"","img":"profile.jpg"}},[_c('HomeHeader')],1),_c('CoreBody',[_c('HomeBody')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }